export const  preventBodyScroll = () => {
    document.body.classList.toggle('no-scroll');
}


//add this in case 2 popups are displayed at the same time
export const  preventBodyScrollDouble = () => {
    document.body.classList.toggle('no-scroll-double');
}